module.exports = __webpack_public_path__ + "img/pass_right.7396b946.jpg";